export class TutorialOverlay {
    constructor(uiManager, economy, actions) {
        this.uiManager = uiManager;
        this.economy = economy;
        this.actions = actions;

        this.steps = [
            {
                id: 'first_guard',
                target: '#runGuard',
                text: '🏥 ¡Bienvenido! Empieza aquí: atiende tu primer paciente para aprender lo básico.'
            },
            {
                id: 'stamina',
                target: '#daily',
                text: '⚡ Cada guardia consume 1 de Energía (máx. 5). Se recupera 1 punto cada 15 minutos: planifica tus turnos.'
            },
            {
                id: 'tutorial_pull',
                target: '#hud-btn-hub',
                text: '🎓 ¡Expediente de regalo! Abre BASE Y MENTORES → LABORATORIO para reclutar tu primer Mentor. Los mentores te dan ventajas únicas durante los casos.',
                requiresLevel: 2
            },
            {
                id: 'atlas',
                target: '#btn-atlas',
                text: '💡 Cada caso que resuelvas añade una Perla Clínica a tu Atlas. Consúltalo para repasar lo aprendido.',
                requiresLevel: 2
            },
            {
                id: 'perks',
                target: '#hud-btn-hub',
                text: '🌳 Tienes Puntos de Habilidad (SP) disponibles. Abre BASE Y MENTORES → STAFF para desbloquear mejoras permanentes.',
                requiresSpMin: 1,
                requiresLevel: 2
            }
        ];

        this.shownSteps = this._loadShown();
    }

    _loadShown() {
        try {
            return new Set(JSON.parse(localStorage.getItem('tutorial_shown_steps') || '[]'));
        } catch {
            return new Set();
        }
    }

    _saveShown() {
        localStorage.setItem('tutorial_shown_steps', JSON.stringify([...this.shownSteps]));
    }

    _markDone(stepId) {
        this.shownSteps.add(stepId);
        this._saveShown();
        if (this.shownSteps.size >= this.steps.length) {
            localStorage.setItem('tutorial_complete', 'true');
        }
    }

    // Called from main.js refreshUI on every state update
    checkProgress(state) {
        if (localStorage.getItem('tutorial_complete')) return;

        for (const step of this.steps) {
            if (this.shownSteps.has(step.id)) continue;

            if (step.requiresLevel && state.playerLevel < step.requiresLevel) continue;
            if (step.requiresSpMin && (state.rpgProfile?.skillPoints || 0) < step.requiresSpMin) continue;

            this._showStep(step, state);
            break; // Show one at a time
        }
    }

    _showStep(step, state) {
        if (step.id === 'tutorial_pull') {
            const tutorialPullBtn = document.querySelector('#pull1') ||
                document.querySelector('[data-action="pull1"]');
            if (tutorialPullBtn && !this.economy.state.firstPullDone) {
                tutorialPullBtn.classList.add('tutorial-highlight');
                const originalPull = this.actions.pull1;
                this.actions.pull1 = async () => {
                    const res = await this.economy.performTutorialPull();
                    if (res) {
                        this.uiManager.showPullAnimation([res]);
                        this.actions.pull1 = originalPull;
                        tutorialPullBtn.classList.remove('tutorial-highlight');
                        this._markDone(step.id);
                    }
                };
            }
        }

        this.uiManager.showTooltip(step.target, step.text);
        this._markDone(step.id);
    }

    startOnboarding() {
        if (localStorage.getItem('tutorial_complete')) return;

        const firstStep = this.steps[0];
        if (!this.shownSteps.has(firstStep.id)) {
            // Hook the guard button to advance to stamina step
            const originalStart = this.actions.startGuard;
            this.actions.startGuard = () => {
                originalStart();
                this._markDone(firstStep.id);
                // Show stamina step after short delay (modal animation)
                setTimeout(() => this.checkProgress(this.economy.state), 600);
                this.actions.startGuard = originalStart;
            };
            this.uiManager.showTooltip(firstStep.target, firstStep.text);
            this._markDone(firstStep.id);
        } else {
            this.checkProgress(this.economy.state);
        }
    }
}
